import { Document, Permission, AuditLogEntry, DocumentNumberRule } from '../types/document';

export const mockDocuments: Document[] = [
  {
    id: '1',
    documentNumber: 'QMS-SOP-2024-001',
    title: 'Quality Management Standard Operating Procedure',
    description: 'This document defines the standard operating procedures and requirements of the quality management system',
    category: 'SOP',
    status: 'Approved',
    currentVersion: '2.0',
    createdAt: '2024-01-15T08:30:00Z',
    createdBy: 'Zhang San',
    updatedAt: '2024-11-20T14:22:00Z',
    updatedBy: 'Li Si',
    tags: ['Quality Management', 'SOP', 'Standard Process'],
    versions: [
      {
        version: '2.0',
        createdAt: '2024-11-20T14:22:00Z',
        createdBy: 'Li Si',
        changes: 'Updated approval workflow and added risk assessment step',
        status: 'Approved',
        isActive: true,
        fileUrl: '/files/qms-sop-2024-001-v2.pdf',
        fileSize: 2457600
      },
      {
        version: '1.0',
        createdAt: '2024-01-15T08:30:00Z',
        createdBy: 'Zhang San',
        changes: 'Initial version',
        status: 'Obsolete',
        isActive: false,
        fileUrl: '/files/qms-sop-2024-001-v1.pdf',
        fileSize: 1843200
      }
    ],
    approvalHistory: [
      {
        id: 'a1',
        documentId: '1',
        version: '2.0',
        approver: 'Wang Wu',
        action: 'Approved',
        comments: 'Approved, meets quality requirements',
        timestamp: '2024-11-21T09:15:00Z',
        level: 2
      },
      {
        id: 'a2',
        documentId: '1',
        version: '2.0',
        approver: 'Zhao Liu',
        action: 'Approved',
        comments: 'Well-documented, approved',
        timestamp: '2024-11-20T16:45:00Z',
        level: 1
      }
    ]
  },
  {
    id: '2',
    documentNumber: 'QMS-WI-2024-015',
    title: 'Equipment Calibration Work Instruction',
    description: 'Detailed instructions on calibration methods and cycles for various measuring instruments',
    category: 'WI',
    status: 'Review',
    currentVersion: '1.1',
    createdAt: '2024-10-05T10:00:00Z',
    createdBy: 'Sun Qi',
    updatedAt: '2024-12-01T11:30:00Z',
    updatedBy: 'Zhou Ba',
    tags: ['Equipment Calibration', 'Work Instruction', 'Metrology'],
    versions: [
      {
        version: '1.1',
        createdAt: '2024-12-01T11:30:00Z',
        createdBy: 'Zhou Ba',
        changes: 'Added calibration instructions for new instrument types',
        status: 'Review',
        isActive: true,
        fileUrl: '/files/qms-wi-2024-015-v1.1.pdf',
        fileSize: 3145728
      },
      {
        version: '1.0',
        createdAt: '2024-10-05T10:00:00Z',
        createdBy: 'Sun Qi',
        changes: 'Initial version',
        status: 'Approved',
        isActive: false,
        fileUrl: '/files/qms-wi-2024-015-v1.0.pdf',
        fileSize: 2621440
      }
    ],
    approvalHistory: [
      {
        id: 'a3',
        documentId: '2',
        version: '1.1',
        approver: 'Wang Wu',
        action: 'Pending',
        comments: '',
        timestamp: '2024-12-01T11:35:00Z',
        level: 1
      }
    ]
  },
  {
    id: '3',
    documentNumber: 'QMS-FORM-2024-032',
    title: 'Non-Conforming Product Handling Record Form',
    description: 'Used to record non-conforming product cases and corrective actions',
    category: 'FORM',
    status: 'Draft',
    currentVersion: '0.9',
    createdAt: '2024-12-10T14:00:00Z',
    createdBy: 'Wu Jiu',
    updatedAt: '2024-12-15T16:20:00Z',
    updatedBy: 'Wu Jiu',
    tags: ['Form', 'Non-Conforming Product', 'Quality Record'],
    versions: [
      {
        version: '0.9',
        createdAt: '2024-12-15T16:20:00Z',
        createdBy: 'Wu Jiu',
        changes: 'Improved form fields',
        status: 'Draft',
        isActive: true,
        fileUrl: '/files/qms-form-2024-032-v0.9.xlsx',
        fileSize: 51200
      }
    ],
    approvalHistory: []
  },
  {
    id: '4',
    documentNumber: 'QMS-SOP-2020-003',
    title: 'Legacy Document Control Procedure (Obsolete)',
    description: 'The 2020 version of the document control procedure, replaced by a newer version',
    category: 'SOP',
    status: 'Obsolete',
    currentVersion: '1.0',
    createdAt: '2020-03-15T09:00:00Z',
    createdBy: 'Zheng Shi',
    updatedAt: '2024-01-20T10:00:00Z',
    updatedBy: 'System Administrator',
    tags: ['Obsolete', 'Document Control'],
    versions: [
      {
        version: '1.0',
        createdAt: '2020-03-15T09:00:00Z',
        createdBy: 'Zheng Shi',
        changes: 'Initial version',
        status: 'Obsolete',
        isActive: true,
        fileUrl: '/files/qms-sop-2020-003-v1.0.pdf',
        fileSize: 1228800
      }
    ],
    approvalHistory: []
  }
];

export const mockPermissions: Permission[] = [
  {
    id: '1',
    role: 'Quality Manager',
    canCreate: true,
    canRead: true,
    canUpdate: true,
    canDelete: true,
    canApprove: true,
    canManagePermissions: true
  },
  {
    id: '2',
    role: 'Document Administrator',
    canCreate: true,
    canRead: true,
    canUpdate: true,
    canDelete: false,
    canApprove: false,
    canManagePermissions: false
  },
  {
    id: '3',
    role: 'Approver',
    canCreate: false,
    canRead: true,
    canUpdate: false,
    canDelete: false,
    canApprove: true,
    canManagePermissions: false
  },
  {
    id: '4',
    role: 'General Employee',
    canCreate: false,
    canRead: true,
    canUpdate: false,
    canDelete: false,
    canApprove: false,
    canManagePermissions: false
  }
];

export const mockAuditLogs: AuditLogEntry[] = [
  {
    id: 'log1',
    timestamp: '2024-12-15T16:20:15Z',
    user: 'Wu Jiu',
    action: 'Update Document',
    documentId: '3',
    documentNumber: 'QMS-FORM-2024-032',
    details: 'Updated document version to 0.9 and improved form fields',
    ipAddress: '192.168.1.105'
  },
  {
    id: 'log2',
    timestamp: '2024-12-01T11:35:22Z',
    user: 'Zhou Ba',
    action: 'Submit for Approval',
    documentId: '2',
    documentNumber: 'QMS-WI-2024-015',
    details: 'Submitted document version 1.1 for approval workflow',
    ipAddress: '192.168.1.102'
  },
  {
    id: 'log3',
    timestamp: '2024-11-21T09:15:30Z',
    user: 'Wang Wu',
    action: 'Approval Granted',
    documentId: '1',
    documentNumber: 'QMS-SOP-2024-001',
    details: 'Second-level approval granted, document status changed to Approved',
    ipAddress: '192.168.1.98'
  },
  {
    id: 'log4',
    timestamp: '2024-11-20T16:45:12Z',
    user: 'Zhao Liu',
    action: 'Approval Granted',
    documentId: '1',
    documentNumber: 'QMS-SOP-2024-001',
    details: 'First-level approval granted',
    ipAddress: '192.168.1.87'
  },
  {
    id: 'log5',
    timestamp: '2024-11-20T14:22:45Z',
    user: 'Li Si',
    action: 'Create New Version',
    documentId: '1',
    documentNumber: 'QMS-SOP-2024-001',
    details: 'Created document version 2.0',
    ipAddress: '192.168.1.75'
  },
  {
    id: 'log6',
    timestamp: '2024-11-15T10:30:00Z',
    user: 'Quality Manager',
    action: 'Download Document',
    documentId: '1',
    documentNumber: 'QMS-SOP-2024-001',
    details: 'Downloaded document version 1.0',
    ipAddress: '192.168.1.50'
  },
  {
    id: 'log7',
    timestamp: '2024-11-10T13:45:20Z',
    user: 'System Administrator',
    action: 'Modify Permissions',
    details: 'Updated permissions for the "Approver" role',
    ipAddress: '192.168.1.1'
  },
  {
    id: 'log8',
    timestamp: '2024-10-25T09:20:15Z',
    user: 'Document Administrator',
    action: 'Search Documents',
    details: 'Search keyword: "Quality Management"',
    ipAddress: '192.168.1.88'
  }
];

export const mockDocumentNumberRules: DocumentNumberRule[] = [
  {
    id: '1',
    prefix: 'QMS-SOP',
    category: 'Standard Operating Procedure',
    sequenceFormat: '001',
    separator: '-',
    includeYear: true,
    includeMonth: false,
    example: 'QMS-SOP-2024-001'
  },
  {
    id: '2',
    prefix: 'QMS-WI',
    category: 'Work Instruction',
    sequenceFormat: '001',
    separator: '-',
    includeYear: true,
    includeMonth: false,
    example: 'QMS-WI-2024-001'
  },
  {
    id: '3',
    prefix: 'QMS-FORM',
    category: 'Form',
    sequenceFormat: '001',
    separator: '-',
    includeYear: true,
    includeMonth: false,
    example: 'QMS-FORM-2024-001'
  },
  {
    id: '4',
    prefix: 'QMS-PROC',
    category: 'Procedure Document',
    sequenceFormat: '001',
    separator: '-',
    includeYear: true,
    includeMonth: false,
    example: 'QMS-PROC-2024-001'
  }
];
